module.exports = __webpack_public_path__ + "img/pasta-al-pomodoro-thumb.cb4d2c72.png";